import { render, staticRenderFns } from "./DatasetFollowers.vue?vue&type=template&id=2f723215&scoped=true"
import script from "./DatasetFollowers.vue?vue&type=script&lang=js"
export * from "./DatasetFollowers.vue?vue&type=script&lang=js"
import style0 from "./DatasetFollowers.vue?vue&type=style&index=0&id=2f723215&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f723215",
  null
  
)

export default component.exports